import { getPath } from '@/router/common'

const baseUrl = {
  title: '上缴账款',
  path: 'Payment'
}

export default [
  {
    path: getPath('PaymentIndex', baseUrl),
    name: 'Payment_PaymentIndex',
    component: () => import(/* webpackChunkName: "Payment_PaymentIndex" */ '@/views/payment/paymentIndex/index.vue'),
    meta: {
      title: '上缴账款'
    }
  },
  {
    path: getPath('PaymentConfirm', baseUrl),
    name: 'Payment_PaymentConfirm',
    component: () => import(/* webpackChunkName: "Payment_PaymentConfirm" */ '@/views/payment/paymentConfirm/index.vue'),
    meta: {
      title: '到款确认'
    }
  }
]
